import { render, staticRenderFns } from "./Popout.vue?vue&type=template&id=2167e980&"
import script from "./Popout.vue?vue&type=script&lang=js&"
export * from "./Popout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports